import { Exclude, Expose, Type } from 'class-transformer';
import { ClassType } from 'class-transformer/ClassTransformer';
import { LiveDataReportType } from './live-data-report-type';

// To make generics work with class-transformer Function is required
// https://github.com/typestack/class-transformer#working-with-generics
export class LiveDataReport<T> {
  @Expose({ name: 'side_number' })
  sideNumber: string;

  @Expose({ name: 'report_type' })
  reportType: LiveDataReportType;

  @Expose({ name: 'report_data' })
  @Type(report => (report.newObject as LiveDataReport<T>).type)
  reportData: T;

  @Exclude()
  private type: ClassType<any> | null;

  static getName(): string {
    return 'LiveDataReport';
  }

  constructor(type: ClassType<any> | null) {
    this.type = type;
  }
}
